import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { UpdateUserRequest } from '@/api/handlers/resources/users/requests';
import type { UserWriteResponse } from '@/api/handlers/resources/users/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { UserQueryKeys } from './userQueryKeys';

export type UpdateUserVariables = {
    id: string;
    body: UpdateUserRequest;
};

export const useUpdateUserMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<UserWriteResponse>,
        Error,
        UpdateUserVariables
    >({
        mutationFn: ({ id, body }) => apiClient.users.updateUser(id, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({ queryKey: UserQueryKeys.all });
            }
        },
    });
};
